var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReportDetailUser = function SvgReportDetailUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "reportDetailUser_svg__a",
    width: "106.8%",
    height: "130.7%",
    x: "-3.4%",
    y: "-12.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 1,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 0.5,
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    "in": "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#444",
    fillRule: "nonzero",
    filter: "url(#reportDetailUser_svg__a)",
    transform: "translate(-656 -76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M667.206 81.284a4.282 4.282 0 1 0-6.424 3.705 5.93 5.93 0 0 0-3.782 5.52.49.49 0 1 0 .98 0 4.95 4.95 0 0 1 4.945-4.943 4.286 4.286 0 0 0 4.281-4.282m-4.281 3.3a3.3 3.3 0 1 1 .001-6.6 3.3 3.3 0 0 1-.001 6.6m7.107 5.407h-4.541a.49.49 0 1 0 0 .98h4.541a.49.49 0 1 0 0-.98m0-2.418h-3.513a.49.49 0 1 0 0 .98h3.513a.49.49 0 0 0 0-.98m-3.057-1.719c0 .27.22.49.49.49h2.567a.49.49 0 1 0 0-.98h-2.567a.49.49 0 0 0-.49.49"
  }))));
};
export default SvgReportDetailUser;